
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
components: {
cmBlank,cmLoadmore,Datetime
},
data(){
return {
keyword:'',
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
list:[],
where:[],
hasNext:0,
pageFlag:2,
lastId:0,
endDate:'',
startDate:'',
index:0,
dateStatus:false,
}
},
mounted(){

},
methods: {
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
reset(){
this.keyword = '';
this.startDate = '';
this.endDate = '';
this.dateStatus = false;
this.index = 0;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
getList(){
this.$api.arrivaled({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},3000)
}
},
}



// WEBPACK FOOTER //
// ./src/pages/arrivaled.vue